import React from 'react'
import { Link } from 'react-router-dom'
import { ChevronLeftIcon } from './icons'

/**
 * @param {{
 *   title: import('react').ReactNode,
 *   description?: import('react').ReactNode,
 *   backTo?: string,
 *   backLabel?: import('react').ReactNode,
 *   actions?: import('react').ReactNode,
 * }} props
 */
const KarteraPageHeader = ({ title, description, backTo, backLabel, actions }) => (
    <header className="flex flex-wrap items-end justify-between gap-3.5">
        <div className="flex min-w-0 flex-col gap-1">
            {backTo && (
                <Link to={backTo} className="inline-flex min-h-7 items-center gap-1.5 self-start text-[13px] text-k-muted hover:text-brand-indigo">
                    <ChevronLeftIcon />
                    {backLabel}
                </Link>
            )}
            <h1 className="m-0 text-[28px] font-extrabold tracking-[-0.03em] text-k-ink">{title}</h1>
            {description && <p className="m-0 text-sm text-k-muted">{description}</p>}
        </div>
        {actions && <div className="flex flex-wrap items-center gap-2">{actions}</div>}
    </header>
)

export default KarteraPageHeader
